import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faSchool,
  faUniversity,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import { Experience } from "./Skillss";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const generateDots = (count) => {
    const dots = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 10 + 5;
      const opacity = Math.random() * (1 - 0.3) + 0.3; // Random opacity between 0.3 and 1
      dots.push(
        <div
          key={i}
          className="dot"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            opacity: opacity,
            animationDuration: `${Math.random() * 5 + 3}s`,
          }}
        ></div>
      );
    }
    return dots;
  };

  return (
    <section className="education-skill" id="education-skill">
      <style jsx>{`
        .education-bx {
          margin-bottom: 50px;
          color: #fff;
        }
        .timeline {
          position: relative;
          padding-left: 40px;
        }
        .timeline:before {
          content: "";
          position: absolute;
          top: 0;
          left: 20px;
          height: 100%;
          width: 2px;
          background: #fff;
        }
        .timeline-item {
          position: relative;
          margin-bottom: 20px;
          padding-left: 20px;
        }
        .timeline-item:before {
          content: "";
          position: absolute;
          top: 0;
          left: -8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #fff;
          border: 2px solid #fff;
        }
        .timeline-item .timeline-content {
          padding: 10px 20px;
          background: #1a1a1a;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
        .timeline-item .timeline-content h3 {
          margin-top: 0;
          color: #fff;
        }
        .timeline-item .timeline-content span {
          display: block;
          margin-bottom: 5px;
          color: #bbb;
        }
        .timeline-item .timeline-content p {
          margin-bottom: 0;
          color: #fff;
        }
        .skill-bx {
          margin-top: 50px;
        }
        .skill-bx h2,
        .skill-bx p {
          color: #fff;
        }
        .item h5 {
          color: #fff;
        }
        .experience-bx {
          margin-top: 50px;
        }
        .experience-bx h2 {
          color: #fff;
          margin-bottom: 20px;
        }
        .experience-item {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          color: #fff;
        }
        .experience-item .icon {
          margin-right: 15px;
          color: #fff;
        }
        .experience-item .content {
          flex: 1;
        }
        .experience-item .content h3 {
          margin: 0;
          color: #fff;
        }
        .experience-item .content span {
          display: block;
          margin-bottom: 5px;
          color: #bbb;
        }
        .experience-item .content p {
          margin: 0;
        }
        .education-skill {
          background: linear-gradient(
            180deg,
            rgba(128, 0, 128, 0.4),
            rgba(0, 0, 128, 0.4),
            rgba(0, 128, 128, 0.4),
            rgba(0, 0, 128, 0.4)
          );
          padding: 50px 0;
          position: relative;
          overflow: hidden;
        }
        .skill-slider .item {
          background: #333;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
        }
        .background-image-left {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.1;
          z-index: -1;
        }
        .dot {
          position: absolute;
          background: #fff;
          border-radius: 50%;
          animation: float 5s infinite;
        }
        @keyframes float {
          0% {
            transform: translateY(0);
            opacity: 0.6;
          }
          50% {
            transform: translateY(-20px);
            opacity: 0.8;
          }
          100% {
            transform: translateY(0);
            opacity: 0.6;
          }
        }
        .education-bx,
        .skill-bx,
        .experience-bx {
          position: relative;
          z-index: 1;
        }
        .experience-item.full-stack-1 .timeline-content {
          border-radius: 10px;
        }
        .experience-item.full-stack-2 .timeline-content {
          border-radius: 20px;
        }
      `}</style>
      <div className="container">
        {/* Education Section */}
        <div className="row">
          <div className="col-12">
            <div className="education-bx wow zoomIn">
              <h2>Education</h2>
              <div className="timeline">
                <div className="timeline-item">
                  <FontAwesomeIcon icon={faGraduationCap} size="2x" />
                  <div className="timeline-content">
                    <h3>Indian Institute Of Information Technology, Manipur</h3>
                    <span>2021 — 2025</span>
                    <p>BTech Computer Science Engineer</p>
                  </div>
                </div>
                {/* <div className="timeline-item">
                  <FontAwesomeIcon icon={faSchool} size="2x" />
                  <div className="timeline-content">
                    <h3>Bhartiya Vidya Mandir Udham Singh Nagar Sr. Sec. School Ludhiana Panjab, India</h3>
                    <span>2012-2020</span>
                    <p>CSE & PCM, CBSE</p>
                  </div>
                </div> */}
                {/* <div className="timeline-item">
                  <FontAwesomeIcon icon={faUniversity} size="2x" />
                  <div className="timeline-content">
                    <h3>Prem Nagar Near Shiv Mandir School Ludhiana Panjab, India</h3>
                    <span>2005 — 2011</span>
                    <p>Maths and Science, PSEB</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Experience Section */}
        <div id="experience">
          <div className="row">
            <div className="col-12">
              <div className="experience-bx wow zoomIn">
                <h2>Experience</h2>
                <div className="timeline">
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>Software/BlockChain Engineer - •SkyTrade, USA</h3>
                      <span>Feb '24 — Present</span>
                      <ul>
                        <li>
                          Developed and deployed utility NFTs for airspace above
                          land property.
                        </li>
                        <li>
                          Executed comprehensive testing on EVM supporting
                          chains and DePINs; identified and resolved bugs,
                          enhancing system reliability.
                        </li>
                        <li>
                          Conducted in-depth testing on Peaq Network and Canary
                          Network, identifying critical vulnerabilities;
                          contributed to a 20% improvement in network stability
                          and user satisfaction ratings.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="timeline-item full-stack-1">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>Software Engineering Intern - Maroon, USA</h3>
                      <span>Jul '24 — Present</span>
                      <ul><li>DEX exchange ,Fintech ,Finance ,Trading</li></ul>
                      {/* <ul>
    <li>
      <strong>Byte Craft Studios Website:</strong> Developed a robust website using the <strong>MERN stack</strong>. The backend, powered by <strong>Node.js</strong> and <strong>Express.js</strong>, supports a dynamic frontend built with <strong>React</strong>. The site features real-time interactions and a seamless user experience. Check it out <a href="https://laravel.bytecraftstudios.in/" target="_blank" rel="noopener noreferrer">here</a>.
    </li>
    <li>
      <strong>Poonam Enterprises Website:</strong> Created a responsive and interactive website using the <strong>MERN stack</strong>. The <strong>React</strong> frontend is coupled with a backend built using <strong>Node.js</strong> and <strong>Express.js</strong>. The site includes features such as real-time updates and interactive elements, enhanced by <strong>Tailwind CSS</strong> and <strong>Material UI</strong>. Explore the website <a href="https://thepoonamenterprises.in/" target="_blank" rel="noopener noreferrer">here</a>.
    </li>
    <li>
      <strong>Study Notion:</strong> Developed a comprehensive platform for educators using the <strong>MERN stack</strong>. This project includes custom dashboards and real-time updates, and is currently undergoing final testing.
    </li>
    <li>
      <strong>Artist Client Website:</strong> Built an engaging portfolio site for an artist using the <strong>MERN stack</strong>. The website features a dynamic gallery and client interaction tools, and is currently in the testing phase.
    </li>
  </ul> */}
                    </div>
                  </div>
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>Co-Founder - AetherTech, India</h3>
                      <span>Jul '24 — Present</span>
                      <ul>
                        <li>
                          Developed Monitoring Tools for Indian Forest Department specifically for Govt of Manipur.
                        </li>
                        <li>
                          developing  Social Media Post Generator.
                        </li>
                        <li>
                           Provided Solutions to multiple Business.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>Network Engineer (Intern) - Airtel India</h3>
                      <span>Jul '24 — Aug '24</span>
                      
                      <ul>
                        <li>
                      Networking Protocols. 
                        </li>
                        </ul>
                    </div>
                  </div>
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>
                        Software Engineer Intern - MoonWalker-Research Group,
                        California USA
                      </h3>
                      <span>Apr '24 — Jul '24</span>
                      <ul>
                      <li>Software Development ,Finance ,Trading Algorithms.</li></ul>
                    </div>
                  </div>
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <h3>Software/BlockChain Engineer - •Invactor , UAE</h3>
                      <span>Jul '23 — Oct'23</span>
                      <ul>
                      <li>     Contributing almost 15-20% in a Startup as a part of
                        core team of top 5 responsible in developing the
                        product.
                      </li></ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Experience></Experience>
        </div>
      </div>
      <div className="background-image-left">
        {generateDots(100)}
        <img
          className="background-image-left"
          src={colorSharp}
          alt="background"
        />
      </div>
    </section>
  );
};
